/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, disable, mediaQuery } from 'utils/styles/style_helpers';



// ********* HELPERS ********* //
const customizeThinnestStyles = {
	'& .grouper': {
		flexDirection: 'column',
		alignItems: 'center',
		'& .group': {
			width: '90%',
			marginTop: pxToEm(20),
			'&:nth-child(2)': {
				order: '-1',
				marginTop: '0'
			}
		}
	},
	'& .controls': {
		position: 'relative',
	},
};



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : CUSTOMIZE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	customize: {
		position: 'relative',
		overflow: 'hidden', // needed to prevent horizontal scroll caused by grouper div
		// minHeight: props => (!props.content || props.noLiveContents) ? pxToEm(700) : props.isNewEmbedFlow ? pxToEm(890) : pxToEm(860),
		'& #content': {
			paddingLeft: pxToEm(0),
			paddingRight: pxToEm(0),
			paddingBottom: pxToEm(0),
		},
		// '& .controls': {
		// 	position: 'absolute',
		// 	width: '100%',
		// 	bottom: props => (!props.content && props.noLiveContents) ? pxToEm(20) : 0,
		// },
		'& .embedcontrols': {
			padding: replacePXinStringWithEM(`0px 5%`),
		},
		'& .stepnav': {
			padding: replacePXinStringWithEM(`0px 5%`),
		},
		'& .embedupdatecta': {
			padding: replacePXinStringWithEM(`0px 5%`),
		},
		'& .grouper': {
			display: 'flex',
			justifyContent: 'center',
			'& .group': {
				'&.greyOut>*, .greyOut': {
					extend: disable
				},
				marginRight: pxToEm(8),
				opacity: '0',
				animationDuration: '.2s',
				animationFillMode: 'forwards',
				'&:last-child': {
					marginRight: '0'
				},
				// ..... PAGE PROPERTY EDITOR ..... //
				'&:nth-child(1)': {
					animationName: 'fadeInLeft',
					animationDelay: '.8s',
					flex: '0',
					zIndex: '3',
				},
				// ..... EMBED EDITOR ..... //
				'&:nth-child(2)': {
					animationName: 'fadeInUp',
					animationDelay: '.4s',
					flex: '1',
					minWidth: pxToEm(316),
					zIndex: '4',
					'& .contentindicator, .cta.addcontent': {
						opacity: '0',
						animationDuration: '.2s',
						animationFillMode: 'forwards',
						animationName: 'fadeIn',
					}
				},
				// ..... EMBED PROPERTY EDITOR ..... //
				'&:nth-child(3)': {
					zIndex: 2,
					animationName: 'fadeInRight',
					animationDelay: '.8s',
					flex: '0'
				}
			}
		},
		// ..... CONTENT SELECTOR ..... //
		'& .contentselector': {
			opacity: '0',
			animationDuration: '.2s',
			animationFillMode: 'forwards',
			animationName: 'fadeInUp',
			animationDelay: '.4s',
			zIndex: '1'
		},


		// +++++ RAIL +++++ //
		'&.rail': {
			'& .grouper': {
				'& .group': {
					'&:nth-child(2)': {
						maxWidth: pxToEm(316)
					}
				}
			}
		},
		// +++++ IN-CONTENT +++++ //
		'&.incontent': {
			'& .grouper': {
				'& .group': {
					'&:nth-child(2)': {
						maxWidth: pxToEm(600)
					}
				}
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.customizeThinnest]: {
		customize: {
			extend: customizeThinnestStyles,
		}
	}
});